/* eslint-disable @typescript-eslint/naming-convention */
import { css } from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
const accent = 'var(--primary-darker)';
const accentLight = 'var(--primary-medium)';
const accentDark = '#0b2c59';
const invertedAccent = '#ffffff';
const border = '#f0f0f0';
const numberInputColour = accent;
const text = 'var(--text)';
const error = 'var(--error)';
const success = '#0DB14B';
const mouseMemoirsFont = 'MouseMemoirs, Helvetica, Arial, sans-serif';
const headingFont = 'var(--heading-font)';
const font = 'var(--body-font)';
// eslint-disable-next-line max-len
// const dottiesFont = 'Dotties, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif';
const defaultTheme = {
    accent,
    accentLight,
    invertedAccent,
    numberInputColour,
    border,
    text,
    error,
    success,
    attendeesShowTotals: false,
    showOverviewIcon: false,
    showOverviewTime: false,
    showOverviewDate: false,
    showOverviewAttendees: false,
    stepIconColour: 'var(--primary-medium)',
    includeYear: false,
    defaults: css `
    font: var(--paragraph-font);
    color: var(--text);
    width: 86rem;
    max-width: 100%;
    border-radius: var(--border-radius-sm);
    border: 0.1rem solid (--border);
  `,
    heading: css `
    font-family: ${font};
    font-weight: bold;
  `,
    completedStepsWrapper: css `
    display: flex;
    align-items: flex-start;
  `,
    formGroup: css `
    margin-bottom: 3rem;
    max-width: 100rem;

    &:last-child {
      margin-bottom: 0;
    }
  `,
    halfFormGroup: css `
    width: calc(50% - 1.8rem); // half the gap defined in formFields

    @media screen and (max-width: ${MediaSizes.MD}px) {
      width: calc(50% - 0.5rem);
      // Should be the dummy link
      button > span + span {
        display: none;
      }
    }

    @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
      width: 100%;
    }
  `,
    formFields: css `
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0 3.6rem;

    @media screen and (max-width: ${MediaSizes.MD}px){
      gap: 0 1rem;
    }
  `,
    formLabel: css `
    font: var(--heading-four-font);
    color: var(--primary-darker);
    margin-bottom: 1rem;

    svg {
      top: -0.3rem;
      position: relative;
    },
  `,
    availabilityKey: css ``,
    calendarHeader: css `
    border-bottom: 0.2rem solid var(--border);
    border-radius: var(--border-radius-sm) var(--border-radius-sm) 0 0;
  `,
    calendarDay: css `
    height: 3.2rem;
    user-select: none;

    // remove circle hover effect
    &:hover {
      &::before {
        background-color: transparent;
      }
    }
  `,
    calendarDayHover: css `
    background: transparent;
  `,
    calendarDayHighlighted: css `
    background: white;
  `,
    calendarDayNumber: css `
    font: var(--paragraph-font);
    font-weight: 600;
    color: var(--primary-darker);
    user-select: none;
  `,
    calendarDayNumberDisabled: css `

  `,
    calendarDayNumberHover: css `
    color: var(--primary-darker);
  `,
    calendarDayNumberHighlighted: css ``,
    calendarDayPrice: css `
    font: var(--paragraph-font);
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.4rem;
    letter-spacing: 0;
    color: #a6a6a6;
    margin-top: 0.2rem;
  `,
    calendarDayPriceHover: css `
    color: #a6a6a6;
  `,
    calendarDayPriceHighlighted: css ``,
    calendarHeading: css `
    font: var(--heading-four-font);
    color: var(--primary-darker);
    flex-basis: 25rem;
    user-select: none;

    @media screen and (max-width: ${MediaSizes.MD}px) {
      flex-basis: calc(100% - 10rem);
    }
  `,
    calendarDOW: css `
    font: var(--paragraph-small-font);
    color: var(--text);
    padding: 0 0;
    user-select: none;
  `,
    attendeesHeader: css `
    padding: 1.9rem 1rem 1.5rem;
  `,
    attendeesHeaderTitle: css `
    font-family: ${font};
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.9rem;
    letter-spacing: -0.047rem;
    color: ${accent};
  `,
    attendeesHeaderCopy: css `
    font-family: ${font};
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.7rem;
    letter-spacing: 0;
    color: ${text};
    text-transform: none;
  `,
    attendeesActions: css ``,
    attendeeBands: css `
    background-color: white;
    padding: 1.5rem;
    border: 0.1rem solid var(--border);
    border-radius: var(--border-radius-sm);
  `,
    attendeesInput: css `
    font-weight: 600;
  `,
    attendeeWrapper: css `
    align-items: center;
  `,
    attendeeQuantity: css `
    flex: 0 0 0;
  `,
    attendeeTitle: css `
    font: var(--heading-six-font);
    font-family: ${font};
    font-weight: 600;
    margin-bottom: 0;
    color: ${accent};
  `,
    attendeeCopy: css `
    font-family: ${font};
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.7rem;
    letter-spacing: 0;
    margin-top: 0;
    color: ${text};
    text-transform: none;
  `,
    sessionHeader: css `
    display: none;
    padding: 1.9rem 1rem 1.5rem;
  `,
    sessionHeaderTitle: css `
    font-family: ${font};
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.9rem;
    letter-spacing: -0.047rem;
    color: ${accent};
  `,
    sessionHeaderCopy: css `
    font-family: ${font};
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.7rem;
    letter-spacing: 0;
    color: ${text};
    text-transform: none;
  `,
    sessionsContainer: css `
    padding-bottom: 3rem;
  `,
    sessionsWrapper: css `
    position: relative;
    margin-right: 0;
    background-color: ${invertedAccent};
    overflow: visible;
  `,
    sessionsWrapperAfter: css `
    content: "";
    display: block;
    height: calc(100% - 0.2rem);
    width: 8rem;
    position: absolute;
    right: -2rem;
    top: 0.2rem;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 65%);
    z-index: 10;
    pointer-events: none;
  `,
    sessionCheckbox: css ``,
    sessionNavigationButtonIcon: css `
    content: "";
    background: url("/assets/images/icon--chevron-blue.png") no-repeat center;
    background-size: auto 1.2rem;
    width: 1.2rem;
    height: 1.2rem;
  `,
    sessionNavigationWrapper: css `
    width: 8rem;
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: -4.5rem;
    right: -2rem;
  `,
    sessionCheckboxBefore: css `
    box-shadow: none;
    border-color: var(--primary-medium);
    border-width: 0.2rem;
  `,
    selectedOptionDummyLink: css `
    position: relative;
    font: var(--paragraph-font);
    font-weight: 500;
    color: var(--primary-medium);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  `,
    sessionTime: css `
    font: var(--heading-six-font);
    font-family: ${font};
    font-weight: 600;
    color: ${accent};
  `,
    sessionAvailability: css `
    font: var(--paragraph-font);
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.4rem;
    letter-spacing: 0;
    color: ${text};
  `,
    selectedOptionValue: css `
    &, span {
      font: var(--paragraph-font);
      font-weight: 500;
    }
  `,
    sessionPrice: css `
    font-family: ${font};
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 1.7rem;
    letter-spacing: -0.09rem;
    color: ${text};
    text-transform: none;
  `,
    selectedOptionWrapper: css `
    border: 0.1rem solid var(--border);
    border-radius: var(--border-radius-sm);
    padding: 1.5rem;
    background-color: white;
  `,
    overviewWrapper: css `
    color: white;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 100%;
    display: block;
    padding: 0;

    ${DummyLink} {
      color: var(--primary-light);
    }
  `,
    overviewPrice: css `

  `,
    overviewPriceWrapper: css `
    display: block;
  `,
    overviewPriceLarge: css `
    font: var(--heading-two-font);
    color: white;
    text-align: center;
  `,
    overviewPriceSmall: css `
    font-size: 2rem;
    line-height: 2rem;
    color: white;
    letter-spacing: -0.047rem;
    opacity: 0.5;
    font-family: ${font};
    text-decoration: line-through;
  `,
    // text beneath final price
    overviewSelection: css `
    font: var(--paragraph-font);
    text-align: center;
    a {
      color: var(--primary-medium);

      &:hover {
        text-decoration: underline;
      }
    }
  `,
    monthContainer: css `
    // overriding weird inline styiling, remove important if you figure out where it is added
    width: 100% !important;
    max-width: 100% !important;
    box-shadow: rgba(0, 174, 239, 0.2) 0 1rem 4rem 0;

    .form--loading & {
      box-shadow: initial;
    }
    
    border-radius: var(--border-radius-sm);
  `,
    calendarDayOutside: css `
    visibility: hidden;
    pointer-events: none;
  `,
    calendarDays: css `
    padding: 0 0 0.5rem;
  `,
    voucherStrapLine: css `
    color: white;
    text-align: center;
    justify-content: center;
  `,
    voucherStrapLineIcon: css `
    fill: white;
  `,
    quickPayWrapper: css `
    background-color: black;
    border-radius: 1rem;
    padding: 1.5rem 3rem;
    margin-top: 1.5rem;
    width: 100%;
  `,
    quickPayTitle: css `
    font-family: var(--heading-font);
    font: var(--heading-five-font);
    display: block;
    margin: 0 auto 1rem;
    text-align: center;
    color: white;
  `,
    noticeBackdrop: css `
    background-color: rgba(36, 25, 95,.82);
  `,
    noticeInner: css `
    background-color: white;
    color: var(--primary-darker);
    border-radius: var(--border-radius-md);
    width: 100%;
    max-width: 42rem;

    & > div {
      max-height: 42rem;
      overflow-y: scroll;
    }

    & > svg {
      fill: var(--primary-darker);
    }
  `,
    noticeHeadings: css `
    font-family: ${headingFont};
  `,
    noticeParagraph: css `
    font-family: ${font};
  `,
    successMessageWrapper: css `
    color: ${accent};
  `,
    noSessionText: css `
    font-family: ${font};
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.9rem;
    letter-spacing: -0.047rem;
    color: ${accent};
  `,
    sessionSlide: css `
  `,
    sessionSlideFirst: css `
    margin-left: 0;
  `,
    findingSessionsWrapper: css `
    min-height: 38rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 38rem;
    margin: 0 auto;
    background-color: white;
    padding: 2rem;
  `,
    findingSessionsText: css `
    font-family: ${font};
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.9rem;
    letter-spacing: -0.047rem;
    color: ${accent};
  `,
    findingSessionsPercentage: css `
    color: ${accent};
  `,
    loadingBarWrapper: css `
    background-color: #E9E8EF;
  `,
    loadingBarInner: css `
    background-color: ${accentLight};
  `,
    submitButton: css `
    margin-top: 1rem !important;
    width: 100%;
  `,
    continueButton: css `
    margin-top: 2.5rem;
    width: 100%;
  `,
    successMessageButton: css ``,
    calendarHeaderButtons: css ``,
    submitWrapper: css `
    background-color: var(--primary-darker);
    padding: 1.5rem;
    width: 100%;
    max-width: 40rem;
    border-radius: var(--border-radius-sm);
    margin: 3rem auto 0;
  `,
};
export default defaultTheme;
